<style scoped lang="scss">
    .col-md-12{
      padding:12px 0;
    }
    .col-12{
      padding:12px 0;
    }
  .regist-popup{
    >.ui-row{
      padding:0;
      margin:0;
    }
    .ui-col{
      padding:12px 0;
    }
    
  }
</style>
<template>
  <div class="regist-popup">
        <v-col
            cols="12"
            md="12"
            class="ui-col"
        >
            <input
            type="text"
            class="default-input input margin-left"
            style="width:100%"
            placeholder="부과코드 또는 부과명"
            v-model="imposeInput"
            v-on:keyup.enter="searchImposeInfo()"
            />
            <div class="data-control" style="width:auto">
              <button type="button" class="search-btn" @click="searchImposeInfo()">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                  검색
              </button>
            </div>
        </v-col>
        <v-col
            cols="12"
            md="12"
            class="ui-col"
        >
            <div id="impose-pop-modal" class="real-grid"></div>  
        </v-col>
  </div>
</template>


<script>

import { GridView, LocalDataProvider } from 'realgrid'
import { imposeFields, imposeColumns } from '../views/gridData/ImposePopup.js'
//import { mapGetters } from 'vuex'

let gridView = GridView
let localDataProvider = LocalDataProvider

export default {
  name: 'ImposePopup',
  props : {
    selectImposeEvent : Function,
    deptList: Array
  },
  data() {
    return {
      imposeList: [],
      imposeInput: ''
    }
  },
  methods: {
    getImposePop() {
        this.imposeInput = ''
        this.imposeList = this.deptList
        localDataProvider.setRows(this.imposeList)
        
    },
    searchImposeInfo() {
        // console.log(this.imposeInput)
        var tmpArr = []
        for (var i=0; i<this.imposeList.length; i++) {
            // console.log('imposeCd ====== ' + this.imposeList[i].imposeCd)
            // console.log('imposeCd ====== ' + this.imposeList[i].imposeCd.indexOf(this.imposeInput))
            if (this.imposeList[i].deptCd.indexOf(this.imposeInput) !== -1) {
                tmpArr.push(this.imposeList[i])
                continue
            }

            if (this.imposeList[i].deptNm.indexOf(this.imposeInput) !== -1) {
                tmpArr.push(this.imposeList[i])
            }
        }
        // console.log(tmpArr)
        localDataProvider.setRows(tmpArr)
        // gridView.refresh()
        
    }
  },
  watch: {
  },
  mounted() {
    setTimeout(() => {
      localDataProvider = new LocalDataProvider(false)
      gridView = new GridView('impose-pop-modal')
      gridView.setDataSource(localDataProvider)
      gridView.setCheckBar({
        visible: false
      })
      gridView.setStateBar({
        visible: false
      })
      
      localDataProvider.setFields(imposeFields)
      gridView.setColumns(imposeColumns)

      gridView.displayOptions.fitStyle = "even"
      gridView.displayOptions.selectionStyle = "singleRow"

      var tmpThis = this

      gridView.onCellDblClicked = function (grid, clickData) {
        //console.log('clickData = ' + JSON.stringify(clickData))
        //console.log(grid)
        if(clickData.cellType !== 'header' && clickData.cellType !== 'head'){
          var idx = clickData.dataRow
          var obj = localDataProvider.getJsonRow(idx)
          tmpThis.$emit('selectImposeEvent', obj)
        }
      }

      this.imposeInput = ''
      this.getImposePop()
    }, 500)
  },
  /*computed: {
    ...mapGetters({
      imposePopObj: 'getImposeData'
    })
  },*/
}
</script>